import { SFConnectionDTO } from "groopit-js";
import React from "react";

interface SalesforceLoginProps {
  connectionId?: string;
  onLogin: (connection: SFConnectionDTO) => void;
}

export const SalesforceLogin = (props: SalesforceLoginProps): JSX.Element => {
  const [externalWindow, setExternalWindow] = React.useState<Window>();

  const createPopup = () => {
    // If there was already a popup window open, close it because
    // we're going to generate a new PKCE challenge
    if (externalWindow && !externalWindow.closed) {
      externalWindow.close();
    }

    const width = 500;
    const height = 500;
    const title = "";
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2.5;
    setExternalWindow(
      window.open(
        `/Salesforce/LinkSalesforceAccount?organizationId=${encodeURIComponent(
          props.connectionId ?? "",
        )}&client=Web`,
        title,
        `width=${width},height=${height},left=${left},top=${top}`,
      ) ?? undefined,
    );
  };

  React.useEffect(() => {
    const onMessageReceived = (event: MessageEvent) => {
      if (externalWindow) {
        if (event.data.type === "externalServiceLinked") {
          externalWindow.close();
          props.onLogin(event.data.serviceLink);
        }
      }
    };
    window.addEventListener("message", onMessageReceived);
    return () => {
      window.removeEventListener("message", onMessageReceived);
      if (externalWindow && !externalWindow.closed) {
        externalWindow.close();
      }
    };
  }, [externalWindow]);

  return (
    <button
      className="btn btn-accent"
      type="button"
      onClick={() => createPopup()}
    >
      Sign in to your Salesforce account
    </button>
  );
};
